module.exports = __webpack_public_path__ + "static/swarm_of_cranium_rats-a6b8d932a3112dffbf9f97491930d5d5.jpeg";